const paths = {
  root: '/',
  login: '/login',
  homePage: '/homePage',
  packages: '/packages',
  uploads: '/uploads',
  coupons: {
    list: '/coupons',
    create: '/coupons/create',
    edit: (id) => `/coupons/${id}/edit`,
    view: (id) => `/coupons/${id}`,
  },
};

export default paths;
